import React from 'react';
import { useUser } from '../contexts/UserContext';

const WalletTest: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useUser();

  return (
    <div className="min-h-screen bg-neutral-900 p-8">
      <div className="max-w-2xl mx-auto bg-neutral-800 rounded-lg p-8 border border-neutral-700">
        <h1 className="text-3xl font-bold text-white mb-8">Wallet Test Page</h1>
        
        <div className="space-y-6">
          {/* Loading State */}
          <div className="bg-neutral-700 rounded-lg p-4">
            <p className="text-neutral-300">
              <span className="font-semibold">isLoading:</span>
              <span className="ml-4 text-yellow-400 font-mono">{String(isLoading)}</span>
            </p>
          </div>

          {/* Auth State */}
          <div className="bg-neutral-700 rounded-lg p-4">
            <p className="text-neutral-300">
              <span className="font-semibold">isAuthenticated:</span>
              <span className={`ml-4 font-mono ${isAuthenticated ? 'text-green-400' : 'text-red-400'}`}>
                {String(isAuthenticated)}
              </span>
            </p>
          </div>

          {/* User Data */}
          <div className="bg-neutral-700 rounded-lg p-4">
            <p className="text-neutral-300 font-semibold mb-3">User Data:</p>
            {user ? (
              <div className="space-y-2 text-neutral-300 font-mono text-sm">
                <p><span className="text-neutral-400">ID:</span> {user.id}</p>
                <p><span className="text-neutral-400">Email:</span> {user.email}</p>
                <p>
                  <span className="text-neutral-400">Role:</span>
                  <span className={user.role === 'admin' ? ' text-blue-400' : ' text-orange-400'}>
                    {user.role}
                  </span>
                </p>
                <p><span className="text-neutral-400">KYC Status:</span> {user.kyc_status}</p>
                <p><span className="text-neutral-400">Wallet Address:</span> {user.wallet_address || 'None'}</p>
              </div>
            ) : (
              <p className="text-red-400">No user data</p>
            )}
          </div>

          {/* Access Check */}
          <div className="bg-neutral-700 rounded-lg p-4">
            <p className="text-neutral-300 font-semibold mb-3">Access Check:</p>
            <div className="space-y-2 text-sm">
              {isLoading ? (
                <p className="text-yellow-400">⏳ Still loading...</p>
              ) : !isAuthenticated ? (
                <p className="text-red-400">❌ Not authenticated</p>
              ) : user?.role === 'admin' ? (
                <p className="text-green-400">✅ Admin user can access wallet</p>
              ) : (
                <p className="text-orange-400">⚠️ Regular user can access wallet</p>
              )}
            </div>
          </div>

          {/* Debug Info */}
          <div className="bg-neutral-700 rounded-lg p-4">
            <p className="text-neutral-300 font-semibold mb-3">Debug Info:</p>
            <p className="text-neutral-400 text-sm">
              Check browser console for detailed logs
            </p>
            <button
              onClick={() => {
                console.log('User context state:', { user, isAuthenticated, isLoading });
              }}
              className="mt-3 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition"
            >
              Log Context to Console
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletTest;
